import React, { useEffect, useState } from "react";
import Manubar from "./Manubar";
import Security from "./Security";
import Footer from "./Footer";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import axios from "axios";

const PrivacyPolicy = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/privacy_policy`,
      );
      console.log(res);
      setData(res.data.data[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />
        <Navbar />
      </header>
      {/* header section end */}
      {/* main content start */}
      {/* bread crumb section start */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <a href="index.html">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Privacy Policy{" "}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>
      {/* bread crumb section end */}
      {/* about-section start */}
      <section className="about-section section-mt section-mb">
        <div className="container" style={{ textAlign: "justify", color: "black" }}>
          <div className="row mb-n7 align-items-center">
            <div className="col-xl-6 mb-7">
              <div className="about-content">
                {loading ? (
                  <div className="row justify-content-center pb-5">
                    <div class="loader"></div>
                  </div>
                ) : (
                  <>
                    <h2 className="title mb-5">{data.title}</h2>
                    <p
                      className="mb-5 text-start"
                      dangerouslySetInnerHTML={{ __html: data.description }}
                    ></p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
